import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { gameActions } from "../../action/GameAction";
import { history } from "../../helpers/history";
import { IframeLoad } from "../Games/IframeLoad";
import TooltipNotes from "../../Tooltip/Tooltip";
import { loginActions } from "../../action/loginAction";
class BalanceDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverDate: new Date(),
            allslotgames: localStorage.getItem('Allslotgames') ? JSON.parse(localStorage.getItem('Allslotgames')) : [],
            amount: "",
            CoupenCodeFlag: false,
            CoupenCode: "",
            CoupenCodeError: ""
        };
        this.props.Getplayerbalanceinfo(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        this.props.getBalance(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code);
    }

    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ CoupenCodeError: errorstring })
                break;
            default:
                break;
        }
    }

    showMsg = (msg) => {
        let errorstring = this.props.t(msg)
        this.props.alertError(errorstring);
    }

    handleChange = (e) => {
        try {
            if (e.target.name == 'amount') {
                //if (e.target.value == '' || /^[0-9\b]+$/.test(e.target.value))
                if (e.target.value == '' || /^\d*\.?\d{0,2}$/.test(e.target.value))
                    this.setState({ [e.target.name]: e.target.value });
            }
            else if (e.target.name == 'CoupenCode') {
                this.setState({ [e.target.name]: e.target.value });
            }
        }
        catch (ex) { }
    }

    btmWithdrawAmt = () => {
        if (this.state.amount || parseInt(this.state.amount) <= 0) {
            if (parseInt(this.state.amount) <= 0) {
                this.showMsg("lblvalidamt");
                return;
            }
            else if ((parseInt(this.props.user_info.win_balance) / 100) <= 0) {
                this.showMsg('lbllowbal');
            }
            else if (parseInt(this.state.amount) > (parseInt(this.props.user_info.win_balance) / 100)) {
                this.showMsg('lblgreatet');
            }
            else {
                this.props.Winningtocredits(this.state.amount, this.getRandomNumbers(), this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
                setTimeout(() => {
                    this.props.Getplayerbalanceinfo(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
                }, 2000);
                this.setState({ amount: "" })
            }
        }
        else {
            this.showMsg('lblenteramt');
        }
    }

    getRandomNumbers() {
        const typedArray = new Uint8Array(5);
        const randomValues = window.crypto.getRandomValues(typedArray);
        return randomValues.join('');
    }

    cliambonus = () => {
        this.setState({ CoupenCodeFlag: true })
        if (window.LoadClaimBonus) {
            setTimeout(() => {
                window.LoadClaimBonus()
            }, 100);
        }
    }

    Apply = () => {
        if (this.state.CoupenCode.trim().length <= 0) {
            this.showMsg('Please Enter Coupen Code.');
            return;
        }
        else if (this.state.CoupenCode.trim().length <= 3) {
            this.showMsg('Coupen Code Length is Required.');
            return;
        }
        this.props.ApplyCoupen(this.state.CoupenCode, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
        this.Closebonus();
    }

    Closebonus = () => {
        this.setState({ CoupenCode: "" });
    }


    render() {
        const { t } = this.props;
        let ISCoupenCode = this.state.CoupenCodeError.length > 0;
        return (
            <>
                <div class="myAccCont">
                    <div class="myAccContHead">
                        <h1><img src="./assets/img/icons/tabs-wallet.png" />Wallet</h1>
                    </div>
                    <div class="balance">
                        {/* <p onClick={() => { this.props.changeFlag() }}>{t('lblBack')}</p> */}
                        <div class="walletbalanceCont">

                            <div class="walletContainer">
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/credits.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lblcredits')}</span>
                                        <h4>{this.props.appvariables.currency} {this.props.user_info && this.props.user_info.balance && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.balance) / 100))}</h4>
                                    </div>
                                </div>
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/winnings.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lblWinnings')}</span>
                                        <h4>{this.props.appvariables.currency} {this.props.user_info && this.props.user_info.win_balance && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.win_balance) / 100))}</h4>
                                    </div>
                                </div>
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/Wallet-2.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lblbonus')}</span>
                                        <h4>{this.props.appvariables.currency} {this.props.user_info && this.props.user_info.bonus_amount && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.bonus_amount) / 100))}</h4>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row marTop">
                            <div className="col-md-12">
                                <div className="transorder">
                                    <div className="transButton">
                                        <p>{t('lblcredits')} : {this.props.user_info && this.props.user_info.balance && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.balance) / 100))}</p>
                                    </div>
                                    <div className="transButton">
                                        <p>{t('lblWinnings')} : {this.props.user_info && this.props.user_info.win_balance && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.win_balance) / 100))}</p>
                                    </div>
                                    <div className="transButton">
                                        <p>{t('lblbonus')} : {this.props.user_info && this.props.user_info.bonus_amount && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.bonus_amount) / 100))}</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                            <div class="walletContainer">
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/bonus-win.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lblbonuswin')}</span>
                                        <h4>{this.props.appvariables.currency} {this.props.user_info && this.props.user_info.winbonus_amount && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.winbonus_amount) / 100))}</h4>
                                    </div>
                                    <small>{t("lblHowToWdraw")} ?
                                        <img src="./assets/img/icons/Info.png" />
                                        &nbsp;&nbsp;&nbsp;&nbsp;<TooltipNotes property={this.props} id="my-tooltip" longText={this.props.Amtrestnotes} imgwidth={'10%'} />
                                    </small>
                                </div>
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/winnings.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lblunsettledwin')}</span>
                                        <h4>{this.props.appvariables.currency}  {this.props.user_info && this.props.user_info.unsettled_winbalance && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.unsettled_winbalance) / 100))}</h4>
                                    </div>
                                </div>
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/bonus-win.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lblwithdraweligi')}</span>
                                        <h4>{this.props.appvariables.currency} {this.props.user_info && this.props.user_info.withdraw_eligible_amount && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.withdraw_eligible_amount) / 100))}</h4>
                                    </div>
                                </div>
                            </div>

                            <div class="walletContainer">
                                <div class="wallettext">
                                    <span class="walletImg"><img src="./assets/img/icons/bonus-win.png" /></span>
                                    <div class="walletrgt">
                                        <span>{t('lbltotal')}</span>
                                        <h3>{this.props.appvariables.currency} {this.props.user_info && this.props.user_info.total_balance &&
                                            commonClass.aedCrnyConvert((parseFloat(this.props.user_info.total_balance) / 100))}</h3>
                                    </div>
                                </div>
                                <div class="wallettext">
                                    <a class="activewallet" onClick={() => { this.props.changeFlag(2) }}>{t("lblAddCredit")}</a>
                                </div>
                                <div class="wallettext">
                                    <a class="cuswidth-1" onClick={() => { this.props.changeFlag(3) }}>{t("lblfreeply")}</a>
                                </div>
                                {this.props.user_info && this.props.user_info.bonusbtn_flag == 1 && <div class="wallettext">
                                    <a class="cuswidth-1 openbonus" onClick={() => { this.cliambonus() }}>{t("lblclaimregibonas")}</a>
                                </div>}
                            </div>


                            {/* <div className="row marTop">
                            <div className="col-md-12">
                                <div className="transorder">
                                    <div className="transButton">
                                        <p>{t('lblwithdraweligi')} : {this.props.user_info && this.props.user_info.withdraw_eligible_amount && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.withdraw_eligible_amount) / 100))}</p>
                                    </div>
                                    <div className="transButton">
                                        <p>{t('lblunsettledwin')}: {this.props.user_info && this.props.user_info.unsettled_winbalance && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.unsettled_winbalance) / 100))}</p>
                                    </div>
                                    <div className="transButton">
                                        <p>{t('lblbonuswin')} : {this.props.user_info && this.props.user_info.winbonus_amount && commonClass.aedCrnyConvert((parseFloat(this.props.user_info.winbonus_amount) / 100))}</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                            <div className="row marTop">
                                {this.props.user_info && this.props.user_info.unsettled_winbalance > 0 && <span style={{ fontSize: "12px", color: "red" }}>{t('lblkyccompletemsg')}</span>}
                            </div>

                            {/* <div className="row marTop">
                            <div className="col-md-12">
                                <div className="transorder">
                                    <div className="transButton">
                                        <p>{t('lbltotal')} :
                                            {this.props.user_info && this.props.user_info.total_balance &&
                                                commonClass.aedCrnyConvert((parseFloat(this.props.user_info.total_balance) / 100))}</p>
                                    </div>

                                </div>
                            </div>
                        </div> */}

                            <div class="walletContainer margin-bottom-0">
                                <div class="wallettext padding-bottom-0">
                                    <div class="walletrgt">
                                        <span dangerouslySetInnerHTML={{ __html: t(`lbltranswintocredit`) }}></span>
                                    </div>
                                </div>
                                <div class="wallettext padding-bottom-0">
                                    <input type="text" className="form-control" id="txtAmount" placeholder={`${t('lblAmt')}*`} maxLength={7} name="amount" value={this.state.amount} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                </div>
                                <div class="wallettext padding-bottom-0">
                                    <button type="submit" onClick={() => this.btmWithdrawAmt()}>{t('lblSubmit')}</button>
                                </div>
                            </div>
                        </div >
                    </div >
                </div>
                {this.state.CoupenCodeFlag &&
                    <>
                        <div class="bonusBox" id='bonusBox' style={{ display: "block" }}>
                            <div class="bonusBoxWrap">
                                <a class="lightBoxClose" onClick={() => { this.Closebonus() }} id='lightBoxClose'><img src="./assets/img/icons/pop_close.png" /></a>
                                <img class="bonusTopImg" src="./assets/img/icons/bonus-top.png" />
                                <h3>{t("lblwelcmbonus")}</h3>
                                <p>{t("lblgetmatch")}<br />     </p>
                                <input type="text" className={`form-control ${ISCoupenCode ? "errorBorder" : ""}`} maxLength={20} name="CoupenCode" value={this.state.CoupenCode} onChange={(e) => this.handleChange(e)} autoComplete="off" placeholder="Enter coupon code" />
                                <button onClick={() => { this.Apply() }}>{t("lblapply")}</button>
                            </div>
                        </div>
                        <div class="overlayLogin lightBoxClose" onClick={() => { this.Closebonus() }} style={{ display: "block" }}></div>
                    </>
                }
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { TransactionData } = state.accountReducer;
    const { user_info, Amtrestnotes } = state.gameReducer;
    return { user, TransactionData, appvariables, user_info, Amtrestnotes };
}
const mapActionToProps = {
    alertError: alertActions.error,
    Winningtocredits: accountActions.Winningtocredits,
    Getplayerbalanceinfo: gameActions.Getplayerbalanceinfo,
    getBalance: loginActions.getBalance,
    ApplyCoupen: loginActions.ApplyCoupen

}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(BalanceDetails))
